import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.company.OtherSubscriptionOptions', {
    otherOptions: 'Other options:',
    newSubscriptionOption: 'Add this organisation to new subscription',
});
